<template lang="html">

  <el-form ref="form" v-form :model="form" addAction="distributor/saveDbtDisConfig.action" editAction="distributor/saveDbtDisConfig.action" selectAction="distributor/selectDbtDisConfig.action"
   :rules="rules" label-width="150px">
    <h3 >加油佣金设置</h3>
    <p  style="margin-left:8px;color: #909399" >当用户在自主招募油站加油时，将收取优惠金额的10%作为平台服务费，最低收取0.5元/笔，服务费将按照以下参数设置用于推广佣金奖励。(扣除所有佣金奖励后剩余服务费，则按照合作分成比例以月/季度进行后结算)</p>
    <p style="margin-left:8px;color: #909399">

        <span style="color: red;">举例：若设置招募者奖励5%，经纪人奖励50%，合伙人奖励20%，当用户加油300元，油站优惠30元，即服务费为3元，则：

        招募者获得收益：3x5%=0.15元

        经纪人获得收益：3x50%=1.5元

        合伙人获得收益：3x20%=0.6元

        运营方获得收益：（3-0.15-1.5-0.6）x分成比例
        </span>
    <br>
    </p>
    <el-col :span="8">

          <el-form-item label="油站招募者奖励" prop="gasRecruiterRadio">
              <el-input  v-model.number="form.gasRecruiterRadio" placeholder="请输入金额"  type="text" step="0" >
                  <template slot="append">%</template>
              </el-input>
          </el-form-item>

          <el-form-item label="经纪人奖励" prop="gasAgenRadio">
              <el-input   v-model.number="form.gasAgenRadio" placeholder="请输入金额"  type="text" step="0" >
                  <template slot="append">%</template>
              </el-input>
          </el-form-item>

          <el-form-item label="合伙人奖励" prop="gasDealerRadio">
              <el-input   v-model.number="form.gasDealerRadio" placeholder="请输入金额"  type="text" step="0" >
                  <template slot="append">%</template>
              </el-input>
          </el-form-item>

      </el-col>

      <el-col>
          <el-form-item>
              <el-button type="primary"  >保存</el-button>

          </el-form-item>
      </el-col>

  </el-form>

</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'

export default {
  extends: BasicPager,
  components: {

  },
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      isAdmin: null,
      form: {
        id: null,
        gasRecruiterRadio: null,
        gasAgenRadio: null,
        gasDealerRadio: null
      },
      rules: {
        gasRecruiterRadio: [{
          required: true,
          trigger: 'change',
          message: '油站招募者奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '油站招募者奖励只能为数字！'
        }
        ],
        gasAgenRadio: [{
          required: true,
          trigger: 'change',
          message: '经纪人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '经纪人奖励只能为数字！'
        }],
        gasDealerRadio: [{
          required: true,
          trigger: 'change',
          message: '合伙人奖励不能为空！'
        }, {
          type: 'number',
          trigger: 'change',
          message: '合伙人奖励只能为数字！'
        }]
      }
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    if (userInfo.loginPath === 'channel') {
      this.form.id = this.loginInfo.id
    }
  },
  methods: {

    showMsg: function (dataInfo) {
      if (dataInfo.success) {
        this.$message({
          type: 'success',
          message: dataInfo.errMsg
        })
      } else {
        this.$message({
          type: 'error',
          message: dataInfo.errMsg
        })
      }

      this.selectInfo()
    },
    onAdded: function (dataInfo) {
      this.showMsg(dataInfo)
    },
    onEdited: function (dataInfo) {
      this.showMsg(dataInfo)
    }
  }
}
</script>
